$(document).ready(function () {
    let $container = $(".counter-container");
    let $counterElement = $("#counter");
    let $progressRing = $(".progress-ring__animated");
    let $trackRing = $(".progress-ring__track");
    let $labelMin = $(".label-min");

    let minValue = parseInt($container.data("min"), 10);
    let maxValue = parseInt($container.data("max"), 10);
    let currentValue = parseInt($container.data("value"), 10);

    let totalArc = 283;

    let strokeTrackDashoffset = totalArc - ((minValue / maxValue) * totalArc);
    $trackRing.css("stroke-dashoffset", strokeTrackDashoffset);
    $progressRing.css("stroke-dashoffset", strokeTrackDashoffset);

    let progress = totalArc - ((currentValue / maxValue) * totalArc);


    function startAnimation() {
        gsap.to($counterElement[0], {
            innerHTML: `${(currentValue).toFixed(0)}k`,
            duration: 1,
            snap: { innerHTML: 1 },
            ease: "linear",
        });

        gsap.to($progressRing[0], {
            strokeDashoffset: progress,
            duration: 1,
            ease: "linear",
        });
    }

    function getLabelPosition(current, max, radius, centerX, centerY) {
        let angle = (current / max) * 360;
        let radians = (angle - 90) * (Math.PI / 180);

        let x = centerX + radius * Math.cos(radians);
        let y = centerY + radius * Math.sin(radians);

        return { x, y };
    }

    function updateLabelPosition() {
        let screenWidth = $(window).width();
        let radius, centerX, centerY;

        if (screenWidth >= 1440) {
            radius = 202;
            centerX = 212;
            centerY = 212;
        } else if (screenWidth >= 1024) {
            radius = 152;
            centerX = 159;
            centerY = 159;
        } else {
            radius = 131;
            centerX = 135;
            centerY = 135;
        }


        let labelPos = getLabelPosition(minValue, maxValue, radius, centerX, centerY);

        $labelMin.css({
            left: labelPos.x + "px",
            top: labelPos.y + "px"
        });
    }

    updateLabelPosition();
    $(window).on("resize", updateLabelPosition);

    let observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    startAnimation();
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.5 }
    );

    observer.observe($container[0]);
});